import {Component, Input} from "@angular/core/src/metadata/directives";

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
    @Input() hideUI: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.component.ts